import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { AlertService } from './alert.service';
import { AuthService } from './auth.service';
import { LocalStorageService } from './local-storage.service';
import { UtilsService } from './utils.service';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  baseUrl: string = environment.api.baseUrl;
  headers: HttpHeaders;
  totalNumberOfOrders: number = 0;
  totalNumberOfBatches: number = 0;
  totalNumberOfBatchItems: number = 0;

  constructor(
    private _auth: AuthService,
    private _http: HttpClient,
    private _utilsService: UtilsService
  ) {
    this
      ._auth
      .generateRequestHeaders()
      .then((headers) => {
        this.headers = headers;
      });
  }

  async getFormData(formData: string[]): Promise<any> {
    try {
      const { data } = await this._http
        .post<any>(`${this.baseUrl}/form-data`, formData, {
          headers: this.headers
        })
        .toPromise()
      return data;
    } catch (error) {
      this._utilsService.showError(error);
      return null;
    }
  }
}
